import React from "react";

const OrderStatusYellow = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      style={style}
      stroke="currentColor"
    >
      <g id="Raggruppa_580" transform="translate(-1319 -557)">
        <g id="Tracciato_122" transform="translate(1324 562)" fill="#e3be24">
          <path
            d="M 11 22.5 C 5.210279941558838 22.5 0.5 17.56542015075684 0.5 11.5 C 0.5 5.434579849243164 5.210279941558838 0.5 11 0.5 C 16.78972053527832 0.5 21.5 5.434579849243164 21.5 11.5 C 21.5 17.56542015075684 16.78972053527832 22.5 11 22.5 Z"
            stroke="none"
          />
          <path
            d="M 11 1 C 5.485979080200195 1 1 5.71027946472168 1 11.5 C 1 17.28972053527832 5.485979080200195 22 11 22 C 16.51401901245117 22 21 17.28972053527832 21 11.5 C 21 5.71027946472168 16.51401901245117 1 11 1 M 11 0 C 17.07513046264648 0 22 5.14872932434082 22 11.5 C 22 17.85127067565918 17.07513046264648 23 11 23 C 4.924869537353516 23 0 17.85127067565918 0 11.5 C 0 5.14872932434082 4.924869537353516 0 11 0 Z"
            stroke="none"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};

export default OrderStatusYellow;
